export default __webpack_public_path__ + "static/media/simMasTerceiros.16bbd65a.svg";